import type { ImportStatus, ImportStatusResponse } from '../types';
export function importStatusMapper(r: ImportStatusResponse): ImportStatus {
  return {
    status: r.status,
    totalRows: r.totalRows ?? 0,
    processedRows: r.processedRows ?? 0,
    errorCount: r.errorCount ?? 0,
    errorsSample: r.errorsSample ?? [],
  };
}
